import { createAsyncThunk } from "@reduxjs/toolkit";
import { type UnreadMessages } from "@fitness-app/data-models/entities/Chat";

import { getViewerId, isViewingSomeoneElse } from "../../../helpers/getViewerId";
import { type AsyncThunkCreator } from "../../../index";
import { CHAT_REDUCER_NAME } from "../types";

type Payload = void;

export const fetchUnreadMessages = createAsyncThunk<UnreadMessages, Payload, AsyncThunkCreator<string>>(
  `${CHAT_REDUCER_NAME}/fetchUnreadMessages`,
  async (_payload, { rejectWithValue, extra: { db, auth } }) => {
    const viewerId = await getViewerId(auth);

    const response = await db.from("unread_messages").select("*").eq("id", viewerId).returns<UnreadMessages[]>();

    if (response.error) {
      return rejectWithValue(response.error.message);
    }

    let data = response.data[0];

    if (!data) {
      data = {
        id: viewerId,
        total: 0,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        perChannel: {},
        mutedChannels: [],
        mutedAll: false,
        unreadMessages: [],
      };
      // Seeding a row is a write against the *viewed* user. While previewing a client that is
      // hers, not the viewer's — the read-only guard would reject it and take the whole thunk down
      // with it, leaving the preview without its zero-unread state. The empty record below is all
      // the UI needs; her real row gets created the next time she opens the app herself.
      if (!isViewingSomeoneElse()) {
        await db.from("unread_messages").insert(data);
      }
    }

    return data;
  },
);
